import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/index";
import Ios from "./pages/ios";
import Error from "./pages/error";
import VConsole from 'vconsole';
import Android from "./pages/android";
import Transfer from "./pages/transfer";
import axios from "axios";
import { VersionContext } from "./context";
import "./App.css";

// new VConsole();

interface IVersionData {
  androidVersionInfo: { packageUrl: string; appVersionNo: string } | null;
  iosVersionInfo: { packageUrl: string; appVersionNo: string } | null;
}

function App() {
  const [appVersionData, setAppVersionData] = useState<IVersionData>({
    androidVersionInfo: null,
    iosVersionInfo: null,
  });
  const [apiIsDone, setApiIsDone] = useState<boolean>(false);

  useEffect(() => {
    fetchData();
  }, []);

  // test  "https://api-heystore-1.test.heytea.com/api/service-heystore-api/openapi/getLatestFullVersionInfo"
  const fetchData = async () => {
    const host = window.location.host;
    let apiUrl =
      "https://api-heystore-1.test.heytea.com/api/service-heystore-api/openapi/getLatestFullVersionInfo";
    if (host === "heystore.heytea.com") {
      apiUrl =
        "https://api-heystore.heytea.com/api/service-heystore-api/openapi/getLatestFullVersionInfo";
    }
    try {
      const response = await axios.get(apiUrl);
      if (response.data.code === 0) {
        const res = response?.data?.data;
        setAppVersionData(res || {});
        
      }
      setApiIsDone(true);
    } catch (error) {
      setApiIsDone(true);
      console.error(error);
    }
  };

  return (
    <VersionContext.Provider
      value={{
        appVersionData,
        apiIsDone,
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ios" element={<Ios />} />
          <Route path="/transfer" element={<Transfer />} />
          <Route path="/error" element={<Error />} />
          <Route path="/android" element={<Android />} />
        </Routes>
      </Router>
    </VersionContext.Provider>
  );
}

export default App;
